module.exports = __webpack_public_path__ + "img/needle_product.0c013c72.png";